import script from "./ArticleManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleManagement.vue?vue&type=script&setup=true&lang=js"

import "./ArticleManagement.vue?vue&type=style&index=0&id=57918585&scoped=true&lang=css"

import exportComponent from "D:\\dev\\ai inventory\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57918585"]])

export default __exports__